// extracted by mini-css-extract-plugin
module.exports = {"section":"logo-grid-module--section--1pc3E"};